
import { defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  emits: ['drive', 'back'],
  props: {
    currentPosition: { type: String, default: '' },
    showDots: { type: Boolean, default: false },
  },
  setup() {
    const mainStore = useMainStore();

    return {
      mainStore,
    };
  },
});
